module.exports = __webpack_public_path__ + "img/video_player2.b7456879.svg";